import { reaction, runInAction } from "mobx";
import { initComponentStore } from "@/utils/mobx";

export class PumlPreviewStore {
    active: boolean = false;
    isPuml: boolean = false;
    content: string = "";
    svg: string | null = null;
    scale: number = 1;
    private _fetchGeneration: number = 0;

    constructor() {
        initComponentStore(this, { _fetchGeneration: false });

        reaction(
            () => ({ visible: this.visible, content: this.content }),
            ({ visible, content }) => {
                if (!visible) {
                    runInAction(() => {
                        this.svg = null;
                        this.scale = 1;
                    });
                } else {
                    void this._fetchAndSetSvg(content);
                }
            }
        );
    }

    get visible(): boolean {
        return this.isPuml && this.active;
    }

    setScale(v: number) { this.scale = v; }

    private async _fetchAndSetSvg(content: string) {
        const gen = ++this._fetchGeneration;
        try {
            const resp = await fetch("/api/preview/puml", {
                method: "POST",
                body: content,
            });
            if (gen !== this._fetchGeneration) return;
            if (!resp.ok) throw new Error(`PlantUML render failed: ${resp.status}`);
            const svg = await resp.text();
            if (gen !== this._fetchGeneration) return;
            runInAction(() => { this.svg = svg; });
        } catch {
            if (gen !== this._fetchGeneration) return;
            runInAction(() => { this.svg = ""; });
        }
    }
}
